import { createIcon } from '@chakra-ui/react';

export const ACHWhiteIcon = createIcon({
  displayName: 'ACHWhiteIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
        <path
          d="M7.13086 7.71875H4.63086"
          stroke="white"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.88086 6.5V9"
          stroke="white"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.33047 1.25907L6.31547 1.29407L4.86547 4.65907H3.44047C3.10047 4.65907 2.77547 4.72907 2.48047 4.85407L3.35547 2.76407L3.37547 2.71407L3.41047 2.63407C3.42047 2.60407 3.43047 2.57407 3.44547 2.54907C4.10047 1.03407 4.84047 0.689068 6.33047 1.25907Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.02523 4.75781C8.80023 4.68781 8.56023 4.65781 8.32023 4.65781H4.86523L6.31523 1.29281L6.33023 1.25781C6.40523 1.28281 6.47523 1.31781 6.55023 1.34781L7.65523 1.81281C8.27023 2.06781 8.70023 2.33281 8.96023 2.65281C9.01023 2.71281 9.05023 2.76781 9.08523 2.83281C9.13023 2.90281 9.16523 2.97281 9.18523 3.04781C9.20523 3.09281 9.22023 3.13781 9.23023 3.17781C9.36523 3.59781 9.28523 4.11281 9.02523 4.75781Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7609 7.10016V8.07516C10.7609 8.17516 10.7559 8.27516 10.7509 8.37516C10.6559 10.1202 9.68086 11.0002 7.83086 11.0002H3.93086C3.81086 11.0002 3.69086 10.9902 3.57586 10.9752C1.98586 10.8702 1.13586 10.0202 1.03086 8.43016C1.01586 8.31516 1.00586 8.19516 1.00586 8.07516V7.10016C1.00586 6.09516 1.61586 5.23016 2.48586 4.85516C2.78586 4.73016 3.10586 4.66016 3.44586 4.66016H8.32586C8.57086 4.66016 8.81086 4.69516 9.03086 4.76016C10.0259 5.06516 10.7609 5.99516 10.7609 7.10016Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.355 2.76562L2.48 4.85562C1.61 5.23062 1 6.09563 1 7.10063V5.63563C1 4.21563 2.01 3.03062 3.355 2.76562Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7593 5.63188V7.09688C10.7593 5.99688 10.0293 5.06187 9.0293 4.76187C9.2893 4.11187 9.3643 3.60188 9.2393 3.17688C9.2293 3.13188 9.2143 3.08687 9.1943 3.04688C10.1243 3.52687 10.7593 4.51188 10.7593 5.63188Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
